module.exports = __webpack_public_path__ + "ss-gizmo.svg?03ef68a7857eb6b9b1a25c7daba3ee3f";